import { InfrastructureModel } from "@api/types/infrastructure";
import { httpClient } from "../../httpClient";

type Data = any;

const infraWebApi = "/api/v1/infrastructure/";

export async function getInfra(): Promise<any> {
  try {
    const { data } = await httpClient.get(infraWebApi);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getInfraById(id: number): Promise<any> {
  try {
    if (id) {
      const { data } = await httpClient.get(`${infraWebApi}byid/${id}`);
      return data;
    }
    return null;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function postInfra(payload: InfrastructureModel): Promise<any> {
  try {
    console.log(payload);
    const { data } = await httpClient.post(`${infraWebApi}create`, payload);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function putInfra(
  id: number,
  payload: InfrastructureModel
): Promise<any> {
  try {
    const { data } = await httpClient.put<Data>(
      `${infraWebApi}update/${id}`,
      payload
    );
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export const infrastructure = {
  getInfra,
  getInfraById,
  postInfra,
  putInfra,
};
